export enum MachineStatesEnum {
    AVAILABLE = 'AVAILABLE',
    RUNNING = 'RUNNING',
    MAINTENANCE = 'MAINTENANCE',
    OFFLINE = 'OFFLINE'
}
